<p-dialog
  p-dialog
  appendTo="body"
  header="{{ 'BookingHeaderDetails.Button.EditRelatedBillBtn' | translate }}"
  [style]="{width: '50vw'}"
  [(visible)]="isVisible"
  (onHide)="dialogVisibleChange(false)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true">
  <div class="mt-2">
    <Form [formGroup]="formGroup">
      <div class="p-fluid formgrid grid">
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ 'BookingHeaderDetails.Form.BookingNum' | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingNo | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline"></div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ 'BookingHeaderDetails.Form.DeliveryType' | translate }}</label>
          <div class="col-8 column-value">
            <ng-container [ngSwitch]="bookingModel.deliveryType">
              <div *ngSwitchCase="'DECLARATION'">
                {{ bookingModel?.deliveryType | replaceNullWith:'-' }}
              </div>
              <div *ngSwitchDefault>
                <p-dropdown
                  formControlName="deliveryType"
                  appendTo="body"
                  [options]="deliveryCategoryOptions"
                  [(ngModel)]="bookingModel.deliveryType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{'BookingHeaderDetails.Form.VehicleType' | translate}}</label>
          <div class="col-8 column-value">
            <laas-car-type-selector
              formControlName="carType"
              [(ngModel)]="bookingModel.carType">
            </laas-car-type-selector>
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{'BookingHeaderDetails.Form.TradeTerm' | translate}}</label>
          <div class="col-8 column-value">
            <p-dropdown
              formControlName="incoTerm"
              appendTo="body"
              [(ngModel)]="bookingModel.incoTerm"
              [options]="incoTermOptions"
              [showClear]="true"
              (onChange)="changeIncoTerm($event)"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [disabled]="bookingModel.deliveryType === 'LOCAL'"
              styleClass="p-text-left">
            </p-dropdown>
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{'BookingHeaderDetails.Form.CourierDeliveryCondition' | translate}}</label>
          <div class="col-8 column-value">
            <p-dropdown
              formControlName="expressTerm"
              appendTo="body"
              [options]="expressTermOptions"
              [(ngModel)]="bookingModel.expressTerm"
              [showClear]="true"
              (onChange)="changeExpressTerm($event)"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left">
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedCartonCnt" | translate }}</label>
          <div class="col-8 column-value">
            <p-inputNumber
              formControlName="updatedTotalCaseCnt"
              [(ngModel)]="bookingModel.updatedTotalCaseCnt"
              [showButtons]="false"
              [minFractionDigits]="0"
              [maxFractionDigits]="0"
              placeholder="0"
              styleClass="w-full">
            </p-inputNumber>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedGrossWeight" | translate }}</label>
          <div class="col-8 column-value">
            <p-inputNumber
              formControlName="updatedTotalGrosswgt"
              [(ngModel)]="bookingModel.updatedTotalGrosswgt"
              [showButtons]="false"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              mode="decimal"
              placeholder="0.00"
              styleClass="w-full">
            </p-inputNumber>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedDim" | translate }}</label>
          <div class="col-8 column-value">
            <p-inputNumber
              formControlName="updatedTotalVolumeWeight"
              [(ngModel)]="bookingModel.updatedTotalVolumeWeight"
              [showButtons]="false"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              mode="decimal"
              placeholder="0.00"
              styleClass="w-full">
            </p-inputNumber>
          </div>
        </div>
      </div>
    </Form>
  </div>

  <div class="field">
    <div class="col">
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="saveRelatedBill($event)"></button>
    </div>
  </div>
</p-dialog>
